export default function Logo(){
    return <img className="logo"  src={require('./logo.png')} alt=''/>
}